import React from 'react';
import './HomeSecondBannar.css';


const HomeSecondBannar = () => {
    return (
        <div className='home-second-banner-container'>

        </div>
    );
};

export default HomeSecondBannar;